(() => {
  const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');

  const reveal = (section) => section.classList.add('is-visible');

  const init = (section) => {
    if (section.dataset.sectionRevealInitialized) return;
    if (!('IntersectionObserver' in window) || reducedMotion.matches) {
      reveal(section);
      section.dataset.sectionRevealInitialized = 'true';
      return;
    }

    const observer = new IntersectionObserver(([entry]) => {
      if (!entry.isIntersecting) return;
      reveal(section);
      observer.disconnect();
    }, { threshold: 0.01, rootMargin: '0px 0px -28% 0px' });

    observer.observe(section);
    section.dataset.sectionRevealInitialized = 'true';
  };

  const initAll = (root = document) => root.querySelectorAll?.('[data-section-reveal]').forEach(init);

  initAll();

  if (!window.unfoundSectionRevealEventsBound) {
    window.unfoundSectionRevealEventsBound = true;
    document.addEventListener('shopify:section:load', (event) => initAll(event.target));
    reducedMotion.addEventListener('change', () => initAll());
  }
})();
